// extracted by mini-css-extract-plugin
export default {"link":"link--2ecd99","link__text":"link__text--26b0ba","link_extended":"link_extended--a90cfb","link__icon":"link__icon--90ee2f"};